/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'lodash';
import { useEffect } from 'react';

import PhotoBox from '../photo-box/photo-box';

const PassFail = ({ item, control, watch, getValues, setValue, errors, photoBoxClass = null }) => {
  const onTrueHandler = (value) => {
    let previousPhotoData = {
      ...getValues(`${item.name}`),
      answer: getValues(`${item.name}.answer`) !== value ? value : ''
    };

    const clonedItem = _.cloneDeep(previousPhotoData);
    setValue(`${item.name}`, clonedItem, { shouldDirty: true });
  };

  useEffect(() => {
    if (item?.defaultValuePassFailAndNA && _.isEmpty(getValues(`${item.name}.answer`))) {
      setValue(`${item.name}.answer`, item?.defaultValuePassFailAndNA);
    }
  }, [item.defaultValuePassFailAndNA, getValues(`${item.name}.answer`), setValue, item]);

  const newItem = _.cloneDeep(item);

  return (
    <PhotoBox
      item={{ ...newItem }}
      control={control}
      watch={watch}
      errors={errors}
      getValues={getValues}
      setValue={setValue}
      onTrueFalse={onTrueHandler}
      photoBoxClass={photoBoxClass}
    />
  );
};

export default PassFail;
